import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M478.233792,600.750939 L478.233792,1920 L0.0360450563,1920 L0.0360450563,600.750939 L478.233792,600.750939 Z M1199.08686,598.31189 L1199.08686,676.049061 C1268.89412,630.992741 1349.39474,604.8 1471.46733,604.8 C1869.04431,604.8 1919.98798,913.465832 1919.98798,1182.36195 L1919.98798,1182.36195 L1919.98798,1919.96395 L1439.38723,1919.96395 L1439.38723,1219.12791 C1439.38723,1101.26058 1397.21452,1078.91264 1319.23705,1078.91264 C1245.10438,1078.91264 1199.08686,1102.46208 1199.08686,1219.12791 L1199.08686,1219.12791 L1199.08686,1919.96395 L718.486108,1919.96395 L718.486108,598.31189 L1199.08686,598.31189 Z M239.098874,0 C371.02378,0 478.197747,107.294118 478.197747,239.098874 C478.197747,370.90363 371.02378,478.197747 239.098874,478.197747 C107.294118,478.197747 0,370.90363 0,239.098874 C0,107.294118 107.294118,0 239.098874,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconLinkedinSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconLinkedinSolid, _Component);

  var _super = _createSuper(IconLinkedinSolid);

  function IconLinkedinSolid() {
    _classCallCheck(this, IconLinkedinSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconLinkedinSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconLinkedin",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconLinkedinSolid.displayName = "IconLinkedinSolid";
  return IconLinkedinSolid;
}(Component);

IconLinkedinSolid.glyphName = 'linkedin';
IconLinkedinSolid.variant = 'Solid';
IconLinkedinSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconLinkedinSolid;
export { IconLinkedinSolid };